<template>
	<div class="card-body card-body--padding--2">
		<h3 class="card-title">Shipping Details</h3>
		<div class="checkout__payment-methods payment-methods">
			<ul class="payment-methods__list">											
				<li class="payment-methods__item">
					<label class="payment-methods__item-header">
						<span class="payment-methods__item-radio input-radio">
							<span class="input-radio__body">
								<input class="input-radio__input" name="shipping_diff" type="radio" value="0" @change="isDiffBilling = 0" v-model="isDiffBilling" checked>
								<span class="input-radio__circle"></span>
							</span>
						</span>
						<span class="payment-methods__item-title">Use my Billing Address as my Shipping Address</span>
					</label>
				</li>
			</ul>
		</div>
		<div class="checkout__payment-methods payment-methods">
			<ul class="payment-methods__list">											
				<li class="payment-methods__item" :class="(isDiffBilling) ? 'payment-methods__item--active' : ''">
					<label class="payment-methods__item-header">
						<span class="payment-methods__item-radio input-radio">
							<span class="input-radio__body">
								<input class="input-radio__input" name="shipping_diff" type="radio"  value="1" @change="isDiffBilling = 1" v-model="isDiffBilling">
								<span class="input-radio__circle"></span>
							</span>
						</span>
						<span class="payment-methods__item-title">Ship to a different address?</span>
					</label>
					<div class="payment-methods__item-container">
						<div class="checkout__payment-methods checkout__payment-methods-cc-accordian">						                                    
							<div class="form-row">
								<div class="form-group col-md-6">
									<label for="checkout-shipping-first-name">First Name</label><label class="required-field" >*</label>
									<input type="text" class="form-control" id="checkout-shipping-first-name" placeholder="" v-model="shipping_fname" @change="upShippingDetails"
									:class="errorSName.className">
									<div class="invalid-feedback">{{errorSName.message}}</div>
								</div>
								<div class="form-group col-md-6">
									<label for="checkout-shipping-last-name">Last Name</label><label class="required-field" >*</label>
									<input type="text" class="form-control" id="checkout-shipping-last-name" placeholder="" v-model="shipping_lname" @change="upShippingDetails">
									
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-6">
									<label for="checkout-shipping-email">Email Address</label><label class="required-field" ></label>
									<input type="email" class="form-control" id="checkout-shipping-email" placeholder="" v-model="shipping_email" @change="upShippingDetails"
									:class="errorSEmail.className">
									<div class="invalid-feedback">{{errorSEmail.message}}</div>
								</div>
								<div class="form-group col-md-6">
									<label for="checkout-shipping-phone">Phone</label><label class="required-field" >*</label>
									<input type="text" class="form-control" id="checkout-shipping-phone" placeholder="" v-model="shippingphone" @change="upShippingDetails"
									:class="errorSPhone.className">
									<div class="invalid-feedback">{{errorSPhone.message}}</div>
								</div>
							</div>
							<div class="form-group">
								<label for="checkout-shipping-street-address">Street Address</label><label class="required-field" >*</label>
								<input type="text" class="form-control" id="checkout-shipping-street-address" placeholder=""  v-model="shippingaddress1" @change="upShippingDetails"
								:class="errorSAddress.className">
								<div class="invalid-feedback">{{errorSAddress.message}}</div>
							</div>
							<div class="form-group">
								<label for="checkout-shipping-city">City</label><label class="required-field" >*</label>
								<input type="text" class="form-control" id="checkout-shipping-street-address" placeholder=""  v-model="shippingcity" @change="upShippingDetails"
								:class="errorSCity.className">
								<div class="invalid-feedback">{{errorSCity.message}}</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-6">
									<div class="form-group">
										<label for="checkout-shipping-state">State / Province</label><label class="required-field" >*</label>
										<select id="checkout-shipping-state" class="form-control "  v-model="shippingstate" @change="upShippingDetails" :class="errorSState.className">
											<option value="AL">Select </option>
											<option value="AL">Alabama</option>
											<option value="AK">Alaska</option>
											<option value="AZ">Arizona</option>
											<option value="AR">Arkansas</option>
											<option value="CA">California</option>
											<option value="CO">Colorado</option>
											<option value="CT">Connecticut</option>
											<option value="DE">Delaware</option>
											<option value="DC">District Of Columbia</option>
											<option value="FL">Florida</option>
											<option value="GA">Georgia</option>
											<option value="HI">Hawaii</option>
											<option value="ID">Idaho</option>
											<option value="IL">Illinois</option>
											<option value="IN">Indiana</option>
											<option value="IA">Iowa</option>
											<option value="KS">Kansas</option>
											<option value="KY">Kentucky</option>
											<option value="LA">Louisiana</option>
											<option value="ME">Maine</option>
											<option value="MD">Maryland</option>
											<option value="MA">Massachusetts</option>
											<option value="MI">Michigan</option>
											<option value="MN">Minnesota</option>
											<option value="MS">Mississippi</option>
											<option value="MO">Missouri</option>
											<option value="MT">Montana</option>
											<option value="NE">Nebraska</option>
											<option value="NV">Nevada</option>
											<option value="NH">New Hampshire</option>
											<option value="NJ">New Jersey</option>
											<option value="NM">New Mexico</option>
											<option value="NY">New York</option>
											<option value="NC">North Carolina</option>
											<option value="ND">North Dakota</option>
											<option value="OH">Ohio</option>
											<option value="OK">Oklahoma</option>
											<option value="OR">Oregon</option>
											<option value="PA">Pennsylvania</option>
											<option value="RI">Rhode Island</option>
											<option value="SC">South Carolina</option>
											<option value="SD">South Dakota</option>
											<option value="TN">Tennessee</option>
											<option value="TX">Texas</option>
											<option value="UT">Utah</option>
											<option value="VT">Vermont</option>
											<option value="VA">Virginia</option>
											<option value="WA">Washington</option>
											<option value="WV">West Virginia</option>
											<option value="WI">Wisconsin</option>
											<option value="WY">Wyoming</option>
											<option value="AB">Alberta</option>
											<option value="BC">British Columbia</option>
											<option value="MB">Manitoba</option>
											<option value="NB">New Brunswick</option>
											<option value="NL">Newfoundland and Labrador</option>
											<option value="NS">Nova Scotia</option>
											<option value="ON">Ontario</option>
											<option value="PE">Prince Edward Island</option>
											<option value="QC">Quebec</option>
											<option value="SK">Saskatchewan</option>
											<option value="NT">Northwest Territories</option>
											<option value="NU">Nunavut</option>
											<option value="YT">Yukon</option>	
										</select>
										<div class="invalid-feedback">{{errorSState.message}}</div>
									</div>
								</div>
								<div class="form-group col-md-6">
									<div class="form-group">
										<label for="checkout-shipping-postcode">ZIP / Postal Code</label><label class="required-field" >*</label>
										<input type="text" class="form-control" id="checkout-shipping-postcode"  v-model="shippingzip" @change="upShippingDetails" :class="errorSZip.className">
										<div class="invalid-feedback">{{errorSZip.message}}</div>
									</div>
								</div>
							</div>

							<div class="form-row">
								<div class="form-group col-md-12">
									<div class="form-group">
										<label for="checkout-business-state">Country</label><label class="required-field">*</label>
										<select id="ship_country" name="ship_country" class="form-control" @change="upShippingDetails" v-model="shippingcountry" :class="errorSCountry.className">
											<option value="USA">United States of America</option>
											<option value="CAN">Canada</option>
											<option value="AFG">Afghanistan</option>
											<option value="ALB">Albania</option>
											<option value="DZA">Algeria</option>
											<option value="ASM">American Samoa</option>
											<option value="AND">Andorra</option>
											<option value="AGO">Angola</option>
											<option value="AIA">Anguilla</option>
											<option value="ATG">Antigua & Barbuda</option>
											<option value="ARG">Argentina</option>
											<option value="ARM">Armenia</option>
											<option value="ABW">Aruba</option>
											<option value="AUS">Australia</option>
											<option value="AUT">Austria</option>
											<option value="AZE">Azerbaijan</option>
											<option value="Bahamas">Bahamas</option>
											<option value="Bahrain">Bahrain</option>
											<option value="Bangladesh">Bangladesh</option>
											<option value="Barbados">Barbados</option>
											<option value="Belarus">Belarus</option>
											<option value="Belgium">Belgium</option>
											<option value="Belize">Belize</option>
											<option value="Benin">Benin</option>
											<option value="Bermuda">Bermuda</option>
											<option value="Bhutan">Bhutan</option>
											<option value="Bolivia">Bolivia</option>
											<option value="Bonaire">Bonaire</option>
											<option value="Bosnia & Herzegovina">Bosnia & Herzegovina</option>
											<option value="Botswana">Botswana</option>
											<option value="Brazil">Brazil</option>
											<option value="British Indian Ocean Ter">British Indian Ocean Ter</option>
											<option value="Brunei">Brunei</option>
											<option value="Bulgaria">Bulgaria</option>
											<option value="Burkina Faso">Burkina Faso</option>
											<option value="Burundi">Burundi</option>
											<option value="Cambodia">Cambodia</option>
											<option value="Cameroon">Cameroon</option>
											<option value="Canary Islands">Canary Islands</option>
											<option value="Cape Verde">Cape Verde</option>
											<option value="Cayman Islands">Cayman Islands</option>
											<option value="Central African Republic">Central African Republic</option>
											<option value="Chad">Chad</option>
											<option value="Channel Islands">Channel Islands</option>
											<option value="Chile">Chile</option>
											<option value="China">China</option>
											<option value="Christmas Island">Christmas Island</option>
											<option value="Cocos Island">Cocos Island</option>
											<option value="Colombia">Colombia</option>
											<option value="Comoros">Comoros</option>
											<option value="Congo">Congo</option>
											<option value="Cook Islands">Cook Islands</option>
											<option value="Costa Rica">Costa Rica</option>
											<option value="Cote DIvoire">Cote DIvoire</option>
											<option value="Croatia">Croatia</option>
											<option value="Cuba">Cuba</option>
											<option value="Curaco">Curacao</option>
											<option value="Cyprus">Cyprus</option>
											<option value="Czech Republic">Czech Republic</option>
											<option value="Denmark">Denmark</option>
											<option value="Djibouti">Djibouti</option>
											<option value="Dominica">Dominica</option>
											<option value="Dominican Republic">Dominican Republic</option>
											<option value="East Timor">East Timor</option>
											<option value="Ecuador">Ecuador</option>
											<option value="Egypt">Egypt</option>
											<option value="El Salvador">El Salvador</option>
											<option value="Equatorial Guinea">Equatorial Guinea</option>
											<option value="Eritrea">Eritrea</option>
											<option value="Estonia">Estonia</option>
											<option value="Ethiopia">Ethiopia</option>
											<option value="Falkland Islands">Falkland Islands</option>
											<option value="Faroe Islands">Faroe Islands</option>
											<option value="Fiji">Fiji</option>
											<option value="Finland">Finland</option>
											<option value="France">France</option>
											<option value="French Guiana">French Guiana</option>
											<option value="French Polynesia">French Polynesia</option>
											<option value="French Southern Ter">French Southern Ter</option>
											<option value="Gabon">Gabon</option>
											<option value="Gambia">Gambia</option>
											<option value="Georgia">Georgia</option>
											<option value="Germany">Germany</option>
											<option value="Ghana">Ghana</option>
											<option value="Gibraltar">Gibraltar</option>
											<option value="Great Britain">Great Britain</option>
											<option value="Greece">Greece</option>
											<option value="Greenland">Greenland</option>
											<option value="Grenada">Grenada</option>
											<option value="Guadeloupe">Guadeloupe</option>
											<option value="Guam">Guam</option>
											<option value="Guatemala">Guatemala</option>
											<option value="Guinea">Guinea</option>
											<option value="Guyana">Guyana</option>
											<option value="Haiti">Haiti</option>
											<option value="Hawaii">Hawaii</option>
											<option value="Honduras">Honduras</option>
											<option value="Hong Kong">Hong Kong</option>
											<option value="Hungary">Hungary</option>
											<option value="Iceland">Iceland</option>
											<option value="Indonesia">Indonesia</option>
											<option value="India">India</option>
											<option value="Iran">Iran</option>
											<option value="Iraq">Iraq</option>
											<option value="Ireland">Ireland</option>
											<option value="Isle of Man">Isle of Man</option>
											<option value="Israel">Israel</option>
											<option value="Italy">Italy</option>
											<option value="Jamaica">Jamaica</option>
											<option value="Japan">Japan</option>
											<option value="Jordan">Jordan</option>
											<option value="Kazakhstan">Kazakhstan</option>
											<option value="Kenya">Kenya</option>
											<option value="Kiribati">Kiribati</option>
											<option value="Korea North">Korea North</option>
											<option value="Korea Sout">Korea South</option>
											<option value="Kuwait">Kuwait</option>
											<option value="Kyrgyzstan">Kyrgyzstan</option>
											<option value="Laos">Laos</option>
											<option value="Latvia">Latvia</option>
											<option value="Lebanon">Lebanon</option>
											<option value="Lesotho">Lesotho</option>
											<option value="Liberia">Liberia</option>
											<option value="Libya">Libya</option>
											<option value="Liechtenstein">Liechtenstein</option>
											<option value="Lithuania">Lithuania</option>
											<option value="Luxembourg">Luxembourg</option>
											<option value="Macau">Macau</option>
											<option value="Macedonia">Macedonia</option>
											<option value="Madagascar">Madagascar</option>
											<option value="Malaysia">Malaysia</option>
											<option value="Malawi">Malawi</option>
											<option value="Maldives">Maldives</option>
											<option value="Mali">Mali</option>
											<option value="Malta">Malta</option>
											<option value="Marshall Islands">Marshall Islands</option>
											<option value="Martinique">Martinique</option>
											<option value="Mauritania">Mauritania</option>
											<option value="Mauritius">Mauritius</option>
											<option value="Mayotte">Mayotte</option>
											<option value="Mexico">Mexico</option>
											<option value="Midway Islands">Midway Islands</option>
											<option value="Moldova">Moldova</option>
											<option value="Monaco">Monaco</option>
											<option value="Mongolia">Mongolia</option>
											<option value="Montserrat">Montserrat</option>
											<option value="Morocco">Morocco</option>
											<option value="Mozambique">Mozambique</option>
											<option value="Myanmar">Myanmar</option>
											<option value="Nambia">Nambia</option>
											<option value="Nauru">Nauru</option>
											<option value="Nepal">Nepal</option>
											<option value="Netherland Antilles">Netherland Antilles</option>
											<option value="Netherlands">Netherlands (Holland, Europe)</option>
											<option value="Nevis">Nevis</option>
											<option value="New Caledonia">New Caledonia</option>
											<option value="New Zealand">New Zealand</option>
											<option value="Nicaragua">Nicaragua</option>
											<option value="Niger">Niger</option>
											<option value="Nigeria">Nigeria</option>
											<option value="Niue">Niue</option>
											<option value="Norfolk Island">Norfolk Island</option>
											<option value="Norway">Norway</option>
											<option value="Oman">Oman</option>
											<option value="Pakistan">Pakistan</option>
											<option value="Palau Island">Palau Island</option>
											<option value="Palestine">Palestine</option>
											<option value="Panama">Panama</option>
											<option value="Papua New Guinea">Papua New Guinea</option>
											<option value="Paraguay">Paraguay</option>
											<option value="Peru">Peru</option>
											<option value="Phillipines">Philippines</option>
											<option value="Pitcairn Island">Pitcairn Island</option>
											<option value="Poland">Poland</option>
											<option value="Portugal">Portugal</option>
											<option value="Puerto Rico">Puerto Rico</option>
											<option value="Qatar">Qatar</option>
											<option value="Republic of Montenegro">Republic of Montenegro</option>
											<option value="Republic of Serbia">Republic of Serbia</option>
											<option value="Reunion">Reunion</option>
											<option value="Romania">Romania</option>
											<option value="Russia">Russia</option>
											<option value="Rwanda">Rwanda</option>
											<option value="St Barthelemy">St Barthelemy</option>
											<option value="St Eustatius">St Eustatius</option>
											<option value="St Helena">St Helena</option>
											<option value="St Kitts-Nevis">St Kitts-Nevis</option>
											<option value="St Lucia">St Lucia</option>
											<option value="St Maarten">St Maarten</option>
											<option value="St Pierre & Miquelon">St Pierre & Miquelon</option>
											<option value="St Vincent & Grenadines">St Vincent & Grenadines</option>
											<option value="Saipan">Saipan</option>
											<option value="Samoa">Samoa</option>
											<option value="Samoa American">Samoa American</option>
											<option value="San Marino">San Marino</option>
											<option value="Sao Tome & Principe">Sao Tome & Principe</option>
											<option value="Saudi Arabia">Saudi Arabia</option>
											<option value="Senegal">Senegal</option>
											<option value="Seychelles">Seychelles</option>
											<option value="Sierra Leone">Sierra Leone</option>
											<option value="Singapore">Singapore</option>
											<option value="Slovakia">Slovakia</option>
											<option value="Slovenia">Slovenia</option>
											<option value="Solomon Islands">Solomon Islands</option>
											<option value="Somalia">Somalia</option>
											<option value="South Africa">South Africa</option>
											<option value="Spain">Spain</option>
											<option value="Sri Lanka">Sri Lanka</option>
											<option value="Sudan">Sudan</option>
											<option value="Suriname">Suriname</option>
											<option value="Swaziland">Swaziland</option>
											<option value="Sweden">Sweden</option>
											<option value="Switzerland">Switzerland</option>
											<option value="Syria">Syria</option>
											<option value="Tahiti">Tahiti</option>
											<option value="Taiwan">Taiwan</option>
											<option value="Tajikistan">Tajikistan</option>
											<option value="Tanzania">Tanzania</option>
											<option value="Thailand">Thailand</option>
											<option value="Togo">Togo</option>
											<option value="Tokelau">Tokelau</option>
											<option value="Tonga">Tonga</option>
											<option value="Trinidad & Tobago">Trinidad & Tobago</option>
											<option value="Tunisia">Tunisia</option>
											<option value="Turkey">Turkey</option>
											<option value="Turkmenistan">Turkmenistan</option>
											<option value="Turks & Caicos Is">Turks & Caicos Is</option>
											<option value="Tuvalu">Tuvalu</option>
											<option value="Uganda">Uganda</option>
											<option value="United Kingdom">United Kingdom</option>
											<option value="Ukraine">Ukraine</option>
											<option value="United Arab Erimates">United Arab Emirates</option>
											<option value="Uraguay">Uruguay</option>
											<option value="Uzbekistan">Uzbekistan</option>
											<option value="Vanuatu">Vanuatu</option>
											<option value="Vatican City State">Vatican City State</option>
											<option value="Venezuela">Venezuela</option>
											<option value="Vietnam">Vietnam</option>
											<option value="Virgin Islands (Brit)">Virgin Islands (Brit)</option>
											<option value="Virgin Islands (USA)">Virgin Islands (USA)</option>
											<option value="Wake Island">Wake Island</option>
											<option value="Wallis & Futana Is">Wallis & Futana Is</option>
											<option value="Yemen">Yemen</option>
											<option value="Zaire">Zaire</option>
											<option value="Zambia">Zambia</option>
											<option value="Zimbabwe">Zimbabwe</option>
										</select>
										<div class="invalid-feedback">{{errorSCountry.message}}</div>
									</div>
								</div>
							</div>
							
							
						</div>
					</div>
				</li>
			</ul>
		</div>

		<div class="form-group">
			<label for="checkout-country">Select Shipping Method</label><label class="required-field" >*</label>
			<select id="checkout-shipping-method" class="form-control" v-model="shippingcarrier" @change="upShippingDetails();upShippingRate($event);">
				<!-- <option value="">Choose an Option </option> -->
				<option v-for="carrier in carrierlist" :key="carrier.carriercode" 
				:value="carrier.carriercode" 
				:rate="carrier.carrier_rate" >
					{{ carrier.carriername }}
				</option>

			</select>
			<!-- <div class="invalid-feedback">{{errorSCountry.message}}</div> -->
		</div>

		<div class="form-group">
			<label for="checkout-comment">Order notes <span class="text-muted">(Optional)</span></label>
			<textarea id="checkout-comment" class="form-control" rows="4" v-model="ordernotes" @change="changeNotes"></textarea>
		</div>
	</div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from 'vuex';
import ErrorFields from '../../../mixins/ErrorFields.js';

export default {
	mixins: [ErrorFields],
	data() {
		return {
			// shipping_fname: 'Gregory',
			// shipping_lname: 'shipto',
			// shipping_email: 'nicola@DMS-systems.com',
            // shippingaddress1: '1614 u s Church st',
            // shippingaddress2: '',
            // shippingcity: 'Rocky Mount',
            // shippingstate: 'NC',
            // shippingzip: '27803',
            // shippingphone: 2529852500,

			// shipping details
			shipping_fname: '',
			shipping_lname: '',
			shipping_email: '',
            shippingaddress1: '',
            shippingaddress2: '',
            shippingcity: '',
            shippingstate: '',
            shippingzip: '',
            shippingcountry: 'USA',
            shippingphone: '',
			ordernotes: '',

			shippingcarrier: '',
			shipping_rate: 0,
			carrierlist: [],
			isDiffBilling: false
		}
	},
	computed: {
        ...mapGetters("cart", [
            "totals",
			"carrier"
        ]),
		...mapGetters([
            'storefrontAttributes',
			'customerIndicator'
        ]),
    },

	watch: {
		isDiffBilling() {
			const isDiff = (this.isDiffBilling) ? true : false;

			this.$store.dispatch('cart/updateShippingDiff', {
				shippingDifferent: isDiff
			});
		}
	},
	methods: {
		getCarriers() {
			this.carrierlist = [];

			axiosvl.post(this.$store.getters['api/get_carriers'], 
			{
				"webroutine": {
					"context": {
						"session-key-method": "hidden"
					},
					"fields": {
						"EHCUST": {
							"value": this.$store.getters.customer
						}
					}
				}
			}
			).then((response) => { 
				for (const key in response.data.webroutine.lists.CARRIERS.entries) { 
					const obj = response.data.webroutine.lists.CARRIERS.entries[key];

					this.carrierlist.push({
						carriercode: obj.CFCARR,
						carriername: obj.CFNAME,
						carrier_rate: 0,
					});
				}

				this.getCECarriers();
			}).catch(function (error) { 
				console.log("error - " + error);
			});
		},
		getCECarriers() {
			axiosvl.post(this.$store.getters['api/ship_rate_uri'], 
				{
					"webroutine": {
						"context": {
							"session-key-method": "hidden"
						},
						"fields": {
							// "HOSTURL": {"value": this.$store.getters.hosturl},
							"LW3SFID": { "value": this.$store.getters.storefront },
							"LW3CUSIND": {
								"value": this.$store.getters.customerIndicator
							},
							"LW3SHPRTP": {
								"value": "RATE"
							}
						}
					}
				}
			).then((response) => { 
				const LS_SHIPPINGRATES = response.data.webroutine.lists.LS_SHIPPINGRATES.entries;
				for (const key in LS_SHIPPINGRATES) {
					const obj = LS_SHIPPINGRATES[key];
					// console.table(obj);

					this.carrierlist.push({
						carriercode: obj.LW3JSHPTY,
						carriername: obj.LW3SSHPDS,
						carrier_rate: obj.LW3SHPAMT,
					});

					// this.checkCarriers({
					// 	default : defaultOpt,
					// 	carriercode: obj.LW3JSHPTY,
					// 	carriername: obj.LW3SSHPDS,
					// 	carrier_rate: obj.LW3SHPAMT,
					// });
				}
				
				if (this.carrierlist.length > 0){
					this.shippingcarrier = this.carrierlist[0].carriercode;
					const SRT_VAL = this.storefrontAttributes.find(attr => (attr.type === 'SRT' && attr.indicator == this.customerIndicator)).value;
				
					// SHIPPING depends if the shipping rate type = FLAT
					console.log('SRT_VAL = ' + SRT_VAL);
					if (SRT_VAL == 'FLAT') {
						this.shipping_rate = this.carrierlist[0].carrier_rate;
						this.totals[0].shippingtotal = parseFloat(this.shipping_rate);
						this.totals[0].ordertotal = parseFloat(this.totals[0].ordertotal) + parseFloat(this.shipping_rate);
						this.$store.dispatch("cart/totals", this.totals[0]);
						this.$store.dispatch("cart/calculateTotals");
					}
				}
				
				// this.shippingcarrier = this.$store.getters['cart/carrier'];
				// console.log('carrier = ' + this.carrier);

			}).catch(function (error) {
				console.log("error - " + error);
			});
		},
		upShippingDetails() {
			let cartshipname = '', cartshipaddress1 = '', cartshipaddress2 = '', cartshipstate = '', cartshipzip = '', cartshipctry = '';
			let cartshipcity = '', cartshipphon = 0;

			if (this.isDiffBilling) {
				cartshipname = this.shipping_fname + ' ' + this.shipping_lname;
				cartshipaddress1 = this.shippingaddress1;
				cartshipaddress2 = this.shippingaddress2;
				cartshipstate = this.shippingstate;
				cartshipzip = this.shippingzip;
				cartshipcity = this.shippingcity;
				cartshipphon = this.shippingphone;
				cartshipctry = this.shippingcountry;
			} else {
				let billingdetails = this.$store.getters['cart/billingdetails'];

				cartshipname = billingdetails.billingname;
				cartshipaddress1 = billingdetails.billingaddress1;
				cartshipaddress2 = billingdetails.billingaddress2;
				cartshipcity = billingdetails.billingcity;
				cartshipstate = billingdetails.billingstate;
				cartshipzip = billingdetails.billingzip;
				cartshipctry = billingdetails.billingcountry;
				cartshipphon = billingdetails.billingphone;
			}

            this.$store.dispatch('cart/shippingdetails', {
                "shippingname": cartshipname,
                "shippingaddress1": cartshipaddress1,
				"shippingaddress2": cartshipaddress2,
				"shippingcity": cartshipcity,
				"shippingstate": cartshipstate,
				"shippingcountry": cartshipctry,
				"shippingzip": cartshipzip,
				"shippingphone": cartshipphon,
				"carrier": this.shippingcarrier,
				"ordernotes": this.ordernotes
            });
		},

		toggleShipping() {
			this.$store.dispatch('cart/shippingdetails', {
				shippingDifferent: this.isDiffBilling
			});
		},

		changeNotes() {
			this.$store.dispatch('cart/set_order_notes', {
				'order_notes' : this.ordernotes
			});
		},

		/** update shipping rate
		 * calculate the new totals
		 * calculate totals
		 */
		upShippingRate(e){

			const customerIndicator = this.customerIndicator;
			const SRT_VAL = this.storefrontAttributes.find(attr => (attr.type === 'SRT' && attr.indicator == customerIndicator)).value;
			
			// SHIPPING depends if the shipping rate type = FLAT
			console.log('SRT_VAL = ' + SRT_VAL);
			if (SRT_VAL == 'FLAT') {
				this.shipping_rate = e.target.options.item(e.target.options.selectedIndex).getAttribute('rate');
				// console.log('shipping rate = ' + this.shipping_rate);
				this.totals[0].shippingtotal = parseFloat(this.shipping_rate);
				// this.totals[0].shippingtotal = 10;
				this.totals[0].ordertotal = parseFloat(this.totals[0].ordertotal) + parseFloat(this.shipping_rate);
				// console.table(this.totals);
				this.$store.dispatch("cart/totals", this.totals[0]);
				this.$store.dispatch("cart/calculateTotals");
			}
		},

		checkCarriers(carrier) {
			const check = this.carrierlist.find(c => c.carriercode == carrier.carriercode);
			if(check != undefined){
				const new_carriers = this.carrierlist.map(data => {
					if (carrier.carriercode == data.carriername){
						return carrier;
					}else{
						return data;
					}
				});
				this.carrierlist = new_carriers;
			}else{
				this.carrierlist.push(carrier);
			}
		}
	},
	created() {
		this.upShippingDetails();
		this.getCECarriers();
	},
	updated(){
		this.upShippingDetails();
	}
}
</script>

